<template>
  <div :class="{'nav-open': $sidebar.showSidebar}">
    <notifications transition-name="notification-list" transition-mode="out-in">

    </notifications>
    <router-view name="header"></router-view>
    <transition name="fade"
                mode="out-in">
      <router-view></router-view>
    </transition>
    <router-view name="footer"></router-view>
  </div>
</template>

<script>
  // Loading some plugin css asynchronously
  import 'sweetalert2/dist/sweetalert2.css'
  import 'vue-notifyjs/themes/default.css'
  export default {
    created: function () {
      let _this = this
      this.$http.interceptors.response.use(undefined, function (err) {
        return new Promise(function (resolve, reject) {
          if (err.response.status === 401 && err.config && !err.config.__isRetryRequest) {
            _this.$store.dispatch("$_user/ON_AUTH_STATE_CHANGEL", null);
            _this.$router.push(`/login`)
          }
          throw err;
        });
      });
    }
  }
</script>

<style lang="scss">
.el-select .el-input:hover .el-input__icon, .el-select .el-input:hover input {
    color: inherit !important;
}
</style>
